export const maskToIsoDate = (value: string): string | undefined => {
  const trimmed = value.trim();
  // ожидаем строго dd.mm.yyyy из цифр
  if (!/^\d{2}\.\d{2}\.\d{4}$/.test(trimmed)) {
    return undefined;
  }
  const [dd, mm, yyyy] = trimmed.split('.');
  return `${yyyy}-${mm}-${dd}`;
};

/**
 * Сравнение двух дат в маске dd.mm.yyyy.
 * Возвращает:
 *   -1, если a < b
 *    0, если a == b
 *    1, если a > b
 *   null, если хотя бы одна дата некорректна/пустая
 */
export const compareMaskedDates = (a?: string | null, b?: string | null): number | null => {
  const isoA = a ? maskToIsoDate(a) : undefined;
  const isoB = b ? maskToIsoDate(b) : undefined;

  if (!isoA || !isoB) {
    return null;
  }

  if (isoA < isoB) return -1;
  if (isoA > isoB) return 1;
  return 0;
};
